export default __webpack_public_path__ + "static/media/currency.e5460988.png";